export const apiPrefixes = {
  /** 招聘面试cms配置*/
  cms997: `//cms.cekid.com/publish/997`,
  /** 招聘hostName*/
  recuritment: `//ehr.cekid.com`,
  /** */
  svsesapi: `//svsesapi.haiziwang.com/svses-api/api`,
  /** */
  scbapi: `//scbapi.cekid.com/scb-api`,
  /** */
  sccapi: `//sccapi.cekid.com/scc-api`,
  /** */
  addressapi: `//address.cekid.com`,
  /** */
  userapi: `//user.cekid.com`,
  /** */
  mallbackapi: `//mallback.cekid.com`,
  /** */
  soperationapi: `//soperationapi.cekid.com`,
  /** */
  czjcapi: `//czjcapi.cekid.com/api-c`,
  /** */
  ehr: `//ehr.cekid.com/ehr-web/api/rkhy`,

  ehrapi: `//ehr.cekid.com/ehr-web`
}
